export enum OpeningHoursEnum {
  OPENING_WEEK = "openingWeek",
  ENABLE = "enable",
  OPENING = "opening",
  HAS_BREAK = "hasBreak",
  WORK_BREAK = "workBreak",
  END = "end",
  START = "start",
}

export const DAYS = [
  { label: "Lundi", value: "MONDAY" },
  { label: "Mardi", value: "TUESDAY" },
  { label: "Mercredi", value: "WEDNESDAY" },
  { label: "Jeudi", value: "THURSDAY" },
  { label: "Vendredi", value: "FRIDAY" },
  { label: "Samedi", value: "SATURDAY" },
  { label: "Dimanche", value: "SUNDAY" },
] as const

export const WEEK_DAYS = DAYS.map((day) => day.value)

export type DayValue = (typeof DAYS)[number]["value"]

type DaysFields = Record<
  DayValue,
  Record<
    | "root"
    | "enabled"
    | "openingStart"
    | "openingEnd"
    | "hasBreak"
    | "breakStart"
    | "breakEnd",
    string
  >
>

export const daysFields = DAYS.reduce((output, { value: day }, index) => {
  output[day] = {
    root: `${OpeningHoursEnum.OPENING_WEEK}.${index}`,
    enabled: `${OpeningHoursEnum.OPENING_WEEK}.${index}.${OpeningHoursEnum.ENABLE}`,
    openingStart: `${OpeningHoursEnum.OPENING_WEEK}.${index}.${OpeningHoursEnum.OPENING}.${OpeningHoursEnum.START}`,
    openingEnd: `${OpeningHoursEnum.OPENING_WEEK}.${index}.${OpeningHoursEnum.OPENING}.${OpeningHoursEnum.END}`,
    hasBreak: `${OpeningHoursEnum.OPENING_WEEK}.${index}.${OpeningHoursEnum.HAS_BREAK}`,
    breakStart: `${OpeningHoursEnum.OPENING_WEEK}.${index}.${OpeningHoursEnum.WORK_BREAK}.${OpeningHoursEnum.START}`,
    breakEnd: `${OpeningHoursEnum.OPENING_WEEK}.${index}.${OpeningHoursEnum.WORK_BREAK}.${OpeningHoursEnum.END}`,
  }
  return output
}, {} as DaysFields)

export const openingHoursFields = {
  openingWeek: {
    root: OpeningHoursEnum.OPENING_WEEK,
    ...daysFields,
  },
}
